<div>
    <div class="banner-slidersec">
        <div class="grid grid-cols-1 lg:grid-cols-3 items-center">
            <div class="lg:col-span-2 h-full banner-carousel-col">
                <!-- <img src="../../../assets/images/banner.jpg" alt="sign-in-image" style="width: 100%; height: 100%;"> -->
                <div id="carouselExampleCaptions" class="carousel slide" data-ride="carousel">
                    <!-- <ol class="carousel-indicators">
                        <li data-target="#carouselExampleCaptions" data-slide-to="0" class="active"></li>
                        <li data-target="#carouselExampleCaptions" data-slide-to="1"></li>
                        <li data-target="#carouselExampleCaptions" data-slide-to="2"></li>
                    </ol> -->
                    <div class="carousel-inner">
                        <div class="carousel-item active">
                            <img src="../../../assets/images/img/tms-slide-1.jpg" class="d-block banner-slider"
                                alt="WBSRLM Training">
                            <div class="carousel-caption d-none d-md-block">
                                <h2>WBSRLM Training Management Systems</h2>
                            </div>
                        </div>
                        <div class="carousel-item">
                            <img src="../../../assets/images/img/tms-slide-2.jpg" class="d-block banner-slider"
                                alt="WBSRLM Training">
                            <div class="carousel-caption d-none d-md-block">
                                <h2>WBSRLM Training Management Systems</h2>
                            </div>
                        </div>
                        <div class="carousel-item">
                            <img src="../../../assets/images/img/tms-slide-3.jpg" class="d-block banner-slider"
                                alt="WBSRLM Training">
                            <div class="carousel-caption d-none d-md-block">
                                <h2>WBSRLM Training Management Systems</h2>
                            </div>
                        </div>
                        <div class="carousel-item">
                            <img src="../../../assets/images/img/tms-slide-4.jpg" class="d-block banner-slider"
                                alt="WBSRLM Training">
                            <div class="carousel-caption d-none d-md-block">
                                <h2>WBSRLM Training Management Systems</h2>
                            </div>
                        </div>

                    </div>
                    <button class="carousel-control-prev" type="button" data-target="#carouselExampleCaptions"
                        data-slide="prev">
                        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span class="sr-only">Previous</span>
                    </button>
                    <button class="carousel-control-next" type="button" data-target="#carouselExampleCaptions"
                        data-slide="next">
                        <span class="carousel-control-next-icon" aria-hidden="true"></span>
                        <span class="sr-only">Next</span>
                    </button>
                </div>
            </div>
            <div class="h-full bg-white login-form">
                <div class="flex items-center justify-center gap-x-">
                    <a routerLink="/">
                        <img src="assets/images/logo.png" alt="logo" class="logo-img-web">
                    </a>
                    <!-- <a routerLink="/" class="inline-block max-w-[110px] mb-[10px] md:mb-[13px]">
                        <img src="assets/images/anandadhara_logo.png" alt="logo"
                            class="logo-img2 inline-block dark:hidden">
                        <img src="assets/images/anandadhara_logo.png" alt="logo"
                            class="logo-img2 hidden dark:inline-block">
                    </a> -->
                </div>

                <div class="my-[17px] md:my-[25px]">
                    <h4 class="text-center text-black">
                        Sign In
                    </h4>
                    <p class="text-center text-gray-500 text-xs mt-1 block lg:hidden">
                        WBSRLM Training Management System
                    </p>
                </div>


                <form [formGroup]="signInForm" class="space-y-4">
                    @if(!this.isMultipleAllocationPresent()){
                    <div>
                        <mat-form-field appearance="outline">
                            <mat-label>User Id</mat-label>
                            <input required matInput type="text" [formControl]="signInForm.controls.email"
                                autocomplete="username" autocapitalize="none" autocorrect="off" enterkeyhint="next">
                        </mat-form-field>
                    </div>
                    <div>
                        <mat-form-field appearance="outline">
                            <mat-label>Password</mat-label>
                            <input required matInput [type]="isPasswordVisible ? 'text' : 'password'"
                                [formControl]="signInForm.controls.password" autocomplete="current-password"
                                enterkeyhint="done">
                            <button type="button" mat-icon-button matSuffix (click)="togglePasswordVisibility()"
                                [attr.aria-label]="isPasswordVisible ? 'Hide password' : 'Show password'"
                                class="password-toggle-btn">
                                <mat-icon>{{ isPasswordVisible ? 'visibility_off' : 'visibility' }}</mat-icon>
                            </button>
                        </mat-form-field>
                    </div>
                    }
                    @else {
                    <div>
                        <mat-form-field appearance="outline">
                            <mat-label>Location</mat-label>
                            <mat-select (selectionChange)="onLocationSelectionChanged($event)">
                                @for(office of offices(); track office){
                                <mat-option [value]="office">
                                    {{ office?.description??"" }}
                                </mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>
                    }

                    <button type="submit" class="signin w-full mt-2 disabled:opacity-50 disabled:bg-gray-200"
                        (click)="onSubmit()" [disabled]="signInForm.invalid || !canLogin()">
                        <span class="flex items-center justify-center gap-[5px]">
                            <i class="material-symbols-outlined">
                                login
                            </i>
                            Sign In
                        </span>
                    </button>

                    <a routerLink="/">
                        <p class="flex justify-content-center font-medium items-center gap-1 hover:text-blue-800 mt-3"
                            style="color: #f49054;">
                            <span class="material-symbols-outlined"
                                style="font-size: 20px!important;">keyboard_double_arrow_left </span>Back to Home
                        </p>
                    </a>
                </form>
            </div>
        </div>
    </div>
</div>